export const TRANSLATIONS = {
  SOMETHING_WENT_WRONG: 'Oeps, er is iets misgegaan!',
  DEVICE_NOT_SUPPORTED: 'Deze video kan hier helaas niet worden afgespeeld.',
  TRY_AGAIN: 'Probeer opnieuw',
  WATCH_VIDEO: 'Bekijk de video hier',
  NOT_YET_AVAILABLE: 'De video is helaas nog niet beschikbaar',
  NOT_AVAILABLE_ANYMORE: 'De video is helaas niet meer beschikbaar',
  NOT_FOUND: 'Video helaas niet gevonden',
}

export const GRADIENT_BACKGROUND =
  'https://cldnr.talpa.network/talpa-network/image/fetch/ar_16:9,c_fill,h_540,w_auto/https://static.kijk.nl/images/gradient-background.jpg'

export const AD_BLOCK_KEY = '__ALLOW_ADBLOCK__'
